import React, { useEffect, useState } from "react";
import { Modal, Input, Button, Tag, message, Spin } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import { formatAmount } from "../../config/helpers.js";
import usePayments from "../../hooks/usePayments.js";

export default function AgentPaymentsModal({ open, onClose, drivers, onPaymentSaved }) {
  const [search, setSearch] = useState("");
  const [payingAgent, setPayingAgent] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("");
  const { recordPayment, loading, error, success } = usePayments();
  const [isLoading, setIsLoading] = useState(false);

  const filteredDrivers = drivers.filter((a) =>
    a.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleSavePayment = async () => {
    if (!paymentAmount || isNaN(paymentAmount)) {
      Modal.error({
        title: "Errueur de paiement",
        content: "Vous devez entrer une somme valide",
        okText: "Ok, j'ai compris !"
      });
      return;
    }

    if (paymentAmount > payingAgent.remaining) {
      Modal.error({
        title: "Errueur de paiement",
        content: "La somme que vous rentrez est supérieure à celle que vous devez à cet agent",
        okText: "Ok, j'ai compris !"
      });
      return;
    }

    if (paymentAmount <= 0) {
      Modal.error({
        title: "Errueur de paiement",
        content: "La somme que vous rentrez doit être est supérieure à 0",
        okText: "Ok, j'ai compris !"
      });
      return;
    }
    setIsLoading(true)
    const success = await recordPayment({ type: 'driver', id: payingAgent.id, amount: paymentAmount, method: "cash" });

    if (success) {
      message.success("Paiement enregistré avec succès !");
      if (onPaymentSaved) {
        onPaymentSaved(payingAgent.id, Number(paymentAmount));
      }
      setPaymentAmount("");
      setPayingAgent(null);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose}
        footer={null}
        width={900}
        title="Paiement des agents"
      >
        {/* Search */}
        <Input
          placeholder="Rechercher un agent..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ marginBottom: 16, height: 40, borderRadius: 8 }}
        />

        {loading ? (
          <div
            style={{
              marginTop: "10rem",
              display: "flex",
              width: "100%",
              justifyContent: "center",
              height: "10rem",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <div className="agent-list">
            {filteredDrivers.map((agent) => (
              <div key={agent.id} className="agent-card">
                <div className="agent-header">
                  <div>
                    <h4>{agent.name}</h4>
                    <Tag color="red">{formatAmount(agent.remaining)} à payer</Tag>
                    {/*<Tag>{agent.unpaidTickets} livraisons</Tag>*/}
                  </div>

                  {agent.remaining > 0 && <Button
                    type="primary"
                    icon={<DollarOutlined />}
                    onClick={() => setPayingAgent(agent)}
                  >
                    Payer
                  </Button>}
                </div>

                <div className="agent-footer">
                  {agent.lastPayment ? (
                    <span>
                      Dernier paiement :{" "}
                      <strong>{formatAmount(agent.lastPayment.amount)}</strong> —{" "}
                      Reçu le {agent.lastPayment?.date?.toDate()?.toLocaleDateString("fr-FR")}
                    </span>
                  ) : (
                    <span className="no-payment">
                      Aucun paiement enregistré
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Styles */}
        <style>{`
          .agent-list {
            max-height: 520px;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding-right: 6px;
          }

          .agent-card {
            background: #fff;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            padding: 16px;
            transition: box-shadow 0.2s ease;
          }

          .agent-card:hover {
            box-shadow: 0 8px 24px rgba(0,0,0,0.08);
          }

          .agent-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .agent-header h4 {
            margin: 0 0 4px 0;
          }

          .agent-footer {
            margin-top: 8px;
            font-size: 13px;
            color: #6b7280;
          }

          .no-payment {
            color: #ef4444;
            font-weight: 500;
          }

          .agent-list::-webkit-scrollbar {
            width: 6px;
          }
          .agent-list::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
        `}</style>
      </Modal>

      {/* Payment modal */}
      <Modal
        open={!!payingAgent}
        onCancel={() => setPayingAgent(null)}
        onOk={() => handleSavePayment()}
        okText="Enregistrer le paiement"
        title={payingAgent ? `Paiement – ${payingAgent.name}` : ""}
        okButtonProps={{ disabled: isLoading }}
      >
        <p>
          Montant dû :{" "}
          <strong>{formatAmount(payingAgent?.remaining)}</strong>
        </p>

        <Input
          type="number"
          placeholder="Montant à payer"
          value={paymentAmount}
          onChange={(e) => setPaymentAmount(e.target.value)}
        />
      </Modal>
    </>
  );
}
